import { PropTypes } from 'base/react-libs';
import { Button } from '@evertrue/et-components';
import { useState } from 'react';
import useTasks from 'apps/tasks/hooks/use-tasks';
import EndJourneyModal from 'apps/journeys/components/modals/end-journey-modal';

const CompleteTaskToggle = ({
  step,
  size = 'big',
  task = {},
  onClick = () => {},
  isClickable = true,
  journey,
  optionalStateManagementFunction = () => {},
}) => {
  const { isLastStepOfCadence } = useTasks();
  const [isModalOpen, setModalOpen] = useState(false);

  const getStep = () => {
    return (
      step || {
        step_number: task?.metadata?.step_number,
        day_number: task?.metadata?.day_number,
        title: task?.title,
      }
    );
  };

  const getCurrentJourney = () => {
    return (
      journey || {
        id: task?.metadata?.journey_id,
        name: task?.metadata?.journey_name,
      }
    );
  };

  const handleToggle = async () => {
    const isLastStep = await isLastStepOfCadence(task, step);
    const { completed_at } = task;

    if (isLastStep && !completed_at) {
      // Open the EndJourneyModal if it's the last step
      setModalOpen(true);
    } else {
      // Proceed with normal task completion logic
      onClick(task, step);
    }
  };
  return (
    <>
      <Button type="simple" data-testid="task-completion-toggle" onClick={handleToggle}>
        <div
          aria-label="task-completion-toggle"
          className={
            task.completed_at
              ? `${isClickable ? 'checked-circle--clickable' : 'checked-circle'} checked-circle--${size}`
              : task.status === 'PAUSED'
                ? `${isClickable ? 'paused-icon--clickable' : 'paused-icon'} paused-icon--${size}`
                : `${isClickable ? 'check-circle--clickable' : 'check-circle'} check-circle--${size}`
          }
        />
      </Button>
      <EndJourneyModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        task={task}
        step={getStep()}
        currentJourney={getCurrentJourney()}
        completeTaskStateUpdates={async (task) => {
          await onClick(task, step);
        }}
        optionalStateManagementFunction={optionalStateManagementFunction}
        additionalAlertMessage={step ? '' : 'Please refresh to continue.'}
      />
    </>
  );
};

CompleteTaskToggle.propTypes = {
  step: PropTypes.object,
  size: PropTypes.string,
  task: PropTypes.object,
  onClick: PropTypes.func,
  isClickable: PropTypes.bool,
  journey: PropTypes.object,
  optionalStateManagementFunction: PropTypes.func,
};

export default CompleteTaskToggle;
